module.exports = __webpack_public_path__ + "img/Private & Dealer market value.0559bc9a.jpg";